<template>
	<div>
		<egranty-section-divider
			:small="true"
			text="Typ projektu"
			icon="list"
		></egranty-section-divider>

		<v-card-text>
			<display-text-component
				label="Typ projektu"
				:value="projectTypeName"
				flex="full-width"/>
		</v-card-text>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import DisplayTextComponent from "../../offer/components/DisplayTextComponent";
	import {AgencyContest} from "@/api/generated/AgencyContest";

	export default {
		name: "AgencyChooseProjectTypeReadOnlyView",
		components: {DisplayTextComponent, EgrantySectionDivider},

		data() {
			return {
				types: []
			};
		},

		computed: {
			projectTypeName () {
				if (!this.types) return "";
				let found = this.types.find(item => item.id === this.value);
				if (found) return found.type;
				return "";
			}
		},

		props: {
			contestId: {},
			value: {},
			readonly: {
				type: Boolean,
				default: false
			}
		},

		mounted () {
			AgencyContest.getProjectTypes(
				this,
				this.contestId,
				response => this.types = response
			);
		}
	};
</script>

<style scoped>

</style>
